import React, {useState, Fragment, useEffect} from "react";
import {connect} from "react-redux";
import {translate} from '@elements/translations';
import InvoicesTable from "./InvoicesTable";
import Tooltip from "../../shared/components/Tooltip";
import {formatDate} from "../../shared/utils";

const TableRowItem = ({item}) => {
    const [isPositionsOpen, setIsPositionsOpen] = useState(false);
    const [isInvoicesOpen, setIsInvoicesOpen] = useState(false);

    const getDocumentsCount = () => {
        let count = 0;

        count += item.referencedInvoices?.length;
        count += item.referencedDeliveryNotes?.length;

        if (item.referencedPurchaseOrders?.length) {
            count += 1;
        }

        setTotalDocuments(count);
    }

    const [totalDocuments, setTotalDocuments] = useState(0);
    useEffect(() => {
        getDocumentsCount();
    }, []);

    return (
        <Fragment>
            <tr>
                <th>{item.number}</th>
                <td>{formatDate(item.date, _config.lang)}</td>
                <td>{translate(`order-archive.type.${item.submitType}`)}</td>
                <td>{item.requestor}</td>
                <th>{item.reference}</th>
                <td className={'text-end table__body-actions'}>
                    <div className="d-flex gap-2 justify-content-end align-items-center">
                        {item.links?.href ? (
                            <a href={item.links.href} target={item.links.target} className="btn btn-sm btn-link p-0 text-end">{item.links.label}</a>
                        ) : null}

                        {item.hasInvoicesOrDeliveryNotes ? (
                            <Tooltip className={`btn btn-white btn-border icon-btn ${isInvoicesOpen ? 'text-primary' : ''}`}
                                     trigger="hover"
                                     target={'appContainer'}
                                     children={<>
                                         <span className={`icon ${isInvoicesOpen ? 'icon-close' : 'icon-documents'} icon-btn__icon icon-btn__icon--fill`} aria-label={translate('order-archive.invoice-delivery-notes')}></span>
                                         {!isInvoicesOpen ? (<span className={'icon-btn__count'}>{totalDocuments}</span>) : null}
                                     </>}
                                     content={`${translate('order-archive.invoice-delivery-notes')}`}
                                     onTriggerClick={() => {
                                         setIsInvoicesOpen(!isInvoicesOpen);
                                         setIsPositionsOpen(false)
                                     }}
                            />
                        ) : null}

                        <Tooltip className={`btn btn-white btn-border icon-btn ${isPositionsOpen ? 'text-primary' : ''}`}
                                 trigger="hover"
                                 target={'appContainer'}
                                 children={<span className={`icon ${isPositionsOpen ? 'icon-close' : 'icon-listing'} icon-btn__icon icon-btn__icon--fill`} aria-label={translate('order-archive.positions')}></span>}
                                 content={`${translate('order-archive.positions')}`}
                                 onTriggerClick={() => {
                                     setIsPositionsOpen(!isPositionsOpen);
                                     setIsInvoicesOpen(false)
                                 }}
                        />
                    </div>
                </td>
            </tr>

            {isPositionsOpen ? (
                <tr>
                    <td colSpan={8} className="p-0">
                        <div className="table-responsive">
                            <table className="table table-with-border mb-0">
                                <thead>
                                <tr>
                                    <th>{translate('order-archive.pos-number')}</th>
                                    <th>{translate('order-archive.product-id')}</th>
                                    <th>{translate('order-archive.description1')}</th>
                                    <th>{translate('order-archive.order-quantity')}</th>
                                    <th>{translate('order-archive.unit')}</th>
                                    <th>{translate('order-archive.thickness')}</th>
                                    <th>{translate('order-archive.length')}</th>
                                    <th>{translate('order-archive.width')}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {item.items.map((position, posIndex) => (
                                    <tr key={position.posNumber}>
                                        <td>{position.posNumber}</td>
                                        <td>{position.productId}</td>
                                        <td>{position.description1} <br /> {position.description2}</td>
                                        <td>{position.orderQuantity}</td>
                                        <td>{position.unit}</td>
                                        <td>{position.thickness}&nbsp;{translate('unit.mm')}</td>
                                        <td>{position.length}&nbsp;{translate('unit.mm')}</td>
                                        <td>{position.width}&nbsp;{translate('unit.mm')}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </td>
                </tr>
            ) : null}

            {isInvoicesOpen ? (
                <tr>
                    <td colSpan={8} className="p-0">
                        <div className="table-responsive">
                            <InvoicesTable id={item.number} invoices={item.referencedInvoices} notes={item.referencedDeliveryNotes} orders={[item.referencedPurchaseOrders]} orderDate={item.date} />
                        </div>
                    </td>
                </tr>
            ) : null}
        </Fragment>
    );
};


const mapStateToProps = (state, props) => {
    return {
        item: props.item
    }
};

export const mapDispatchToProps = (dispatch) => {
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(TableRowItem)